export default __webpack_public_path__ + "static/media/SherlockOriginal.6c1a2270.webp";